import http from '../../rest/http';
    

export const userOnboardService = async (data: any) => {
  try {
    const response = await http.post(`/api/v1/dynamic-forms/get-registration-form`,data);
    return response;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const fetchDynamicUsersDetails = async (data: any) => {
  try {
    const response = await http.post(`/api/v1/dynamic-forms/user-details`,data);
    return response;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const updateDynamicUserDetails = async (data: any,userId:any) => {
  try {
    const response = await http.post(`/api/v1/dynamic-forms/update/${userId}`, data, "multipart/form-data");
    return response;
  } catch (error) {
    console.error("Error in updating users:", error);
    throw error;
  }
};
